import React from 'react'
import './SksTasksBigCard.scss'
import bgImage from '../../../../Assets/Sks/img/tasks-big-card-bg.png'

const SksTasksBigCard = ({ title, subTitle }) => {
  return (
    <div
      className='sksTasksBigCard_block'
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <h3>{title}</h3>
      <p>{subTitle}</p>
    </div>
  )
}

export default SksTasksBigCard